// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep .tooltip {\n  z-index: 9999 !important;\n}\n::v-deep .tooltip .tooltip-content {\n    white-space: nowrap;\n    direction: rtl;\n    min-width: -moz-max-content;\n    min-width: max-content;\n    padding: 0.5rem 0.75rem;\n    z-index: 9999 !important;\n}\n", ""]);
// Exports
module.exports = exports;
